import React, { ReactElement } from 'react';
import AntModal, { ModalProps as AntModalProps } from 'antd/lib/modal';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from '../FontAwesomeIcon';

import './Modal.less';
import Styles from './Modal.module.css';
import ButtonStyles from '../Button/Button.module.css';
import { stopPropagation } from '../../lib';

type ModalTitleProps = {
    titleIcon?: ReactElement;
    title?: AntModalProps['title'];
};

type ModalProps = AntModalProps &
    ModalTitleProps & { children?: React.ReactNode };

const ModalTitle = ({ titleIcon, title }: ModalTitleProps): JSX.Element => (
    <>
        <span className={Styles.modalTitle}>{title}</span>
        <span className={Styles.modalTitleIcon}>{titleIcon}</span>
    </>
);

const Modal = ({
    okButtonProps,
    cancelButtonProps,
    titleIcon,
    title,
    closeIcon,
    ...props
}: ModalProps): JSX.Element => (
    <div
        // this prevents unwanted click event propagation in things that are
        // under the modal in the dom.
        onClick={stopPropagation}>
        <AntModal
            closeIcon={closeIcon ?? <FontAwesomeIcon icon={faTimes} />}
            prefixCls={Styles.aldModal}
            {...props}
            okButtonProps={{
                ...okButtonProps,
                prefixCls: ButtonStyles.button,
            }}
            cancelButtonProps={{
                ...cancelButtonProps,
                prefixCls: ButtonStyles.button,
            }}
            title={
                (title || titleIcon) && (
                    <ModalTitle titleIcon={titleIcon} title={title} />
                )
            }
        />
    </div>
);

export { Modal };
export type { ModalProps };
